<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Orçamentos</h3>
        <router-link class="btn btn-success text-white float-right" :to="{ name: 'admin-quotation-customer', params: { quotationId: 'novo'} }" v-if="!isCustomer">Novo orçamento</router-link>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-2">
              <h6 class="m-0">Orçamentos</h6>
            </div>
            <div class="col-10">
              <d-form action="#" class="w-100">
                <d-form-row class="justify-content-end">
                   <!-- Rating -->
                  <d-col cols="12" md="2" class="form-group">
                    <d-select v-model="pagination.rating" >
                      <option value="0">Classificação</option>
                      <option value="1">1 Estrela</option>
                      <option value="2">2 Estrelas</option>
                      <option value="3">3 Estrelas</option>
                      <option value="4">4 Estrelas</option>
                      <option value="5">5 Estrelas</option>
                    </d-select>
                  </d-col>
                   <!-- Status -->
                  <d-col cols="12" md="2" v-if="!isFinancial" class="form-group">
                    <d-select v-model="pagination.statusId" :options="statusOptions" />
                  </d-col>
                   <!-- Priority -->
                  <d-col cols="12" md="2" v-if="!isFinancial" class="form-group">
                    <d-select v-model="pagination.priorityId" :options="options"/>
                  </d-col>
                  <d-col cols="12" md="2" v-if="isAdmin">
                    <autocomplete
                      ref="autocomplete"
                      placeholder="Funcionario"
                      :items="users"
                      item-show="name"
                      :on-input="onInput"
                      :on-select="setUser"
                    ></autocomplete>
                  </d-col>
                  <d-col cols="12" md="4">
                    <div class="input-group input-group-seamless ml-3">
                      <div class="input-group-prepend">
                        <div class="input-group-text"><i class="fas fa-search"></i></div>
                      </div>
                      <input
                        class="navbar-search form-control"
                        type="text"
                        placeholder="Procurar por algo..."
                        aria-label="Search"
                        v-model="pagination.search"
                      >
                    </div>
                  </d-col>
                </d-form-row>
              </d-form>
            </div>
          </div>
          <div class="card-body p-0 pb-3">
            <div class="table-overflow">
              <quotation-table :quotations="quotations.list"></quotation-table>
            </div>
            <pagination :total-items="quotations.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import QuotationTable from '../components/QuotationListTable.vue';
import { _OPEN_MODEL_MODAL_ } from '../components/QuotationModel';

export default {
  name: 'quotation-list',
  components: {
    Pagination,
    Autocomplete,
    QuotationTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        userId: null,
        statusId: null,
        rating: 0,
        priorityId: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
    isFinancial() {
      const { user } = this.$store.state.user;
      if (user.settings.role_id === 1) {
        return true;
      }
      return false;
    },
    users() {
      const { userList } = this.$store.state.user;
      if (userList && userList.list.length) {
        return userList.list;
      }
      return [];
    },
    options() {
      const { priorities } = this.$store.state.quotation;
      if (priorities && priorities.length) {
        return [{ value: null, text: 'Temperatura' }, ...priorities];
      }
      return [];
    },
    statusOptions() {
      const { status } = this.$store.state.quotation;
      if (status && status.length) {
        return [{ value: null, text: 'Status' }, ...status];
      }
      return [];
    },
    quotations() {
      const { quotationList } = this.$store.state.quotation;
      if (quotationList && quotationList.list.length) {
        return quotationList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
      'getUserList',
      'getStatus',
      'getPriorities',
      'getQuotationList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getQuotationList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    getOptions() {
      if (!this.$store.state.quotation.priorities) {
        this.getPriorities();
      }
      if (!this.$store.state.quotation.status) {
        this.getStatus();
      }
    },
    getListUser(name = '') {
      const params = {
        skip: 0,
        take: 10,
        staff: 1,
        search: name,
      };
      this.getUserList(params);
    },
    openChooseModelModal() {
      Events.$emit(_OPEN_MODEL_MODAL_, true);
      this.setToggle({ type: 'clone_quotation_model_modal', bool: true });
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getListUser(name);
      }, 500);
    },
    setUser(user) {
      this.pagination.userId = user.id;
    },
  },
  destroyed() {
    Events.$off('update:pagination');
  },
  mounted() {
    this.getOptions();
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.checkAdmin();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.table-overflow {
  min-height: 20vh;
}
</style>
